import { mutator } from 'satcheljs';
import { setCalendarColorScheme } from '../actions/setCalendarHexColor';

/**
 * Sets whether the user is searching or not.
 */
export let setCalendarColorSchemeMutator = mutator(setCalendarColorScheme, msg => {
    // see updateCachedColors.ts. The issue here is that calendar.colorScheme is a complex prop, so reassigning does not
    // force the mobx update in the calendar left nav to happen automatically. Setting the id to null then back will force the update
    let t = msg.calendar.id;
    msg.calendar.id = null;
    msg.calendar.id = t;
    msg.calendar.colorScheme = msg.colorScheme;
});

export type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
export type { Calendar } from 'owa-calendar-cache';
